// Generated by CoffeeScript 1.12.1
(function() {
  var Helper, url;

  url = require('url');

  Helper = (function() {
    function Helper() {}

    Helper.url = function(arg) {
      var baseUrl, hostname, name, port, protocol, ref, type;
      baseUrl = arg.baseUrl, name = arg.name, type = arg.type;
      ref = url.parse(baseUrl), protocol = ref.protocol, hostname = ref.hostname, port = ref.port;
      return url.format({
        protocol: protocol,
        hostname: hostname,
        port: port,
        pathname: 'resolve',
        query: {
          name: name,
          type: type
        }
      });
    };

    return Helper;

  })();

  module.exports = Helper;

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./~/http-dns/dist/helper.js
// module id = 67
// module chunks = 0